/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

import { Payments } from "App/IOC/Services";

import Columns from "./Columns";
import Filters from "./Filters";

export default {
    Columns,
    Filters,
    Find: Payments.Find
};
